import PitchType from "../../enums/PitchType.js";

// Slider, Curveball, Knuckle Curve, Slurve, Screwball, Breaking Ball, see https://docs.google.com/document/d/1DjxZU1qm8P7BjTRsQSmNxzEbSBT2Oo0nshhw561PAdc/edit#heading=h.gzur83k5ek7y
const breakingBalls = [
    PitchType.Slider.key, PitchType.Curveball.key,
    PitchType.KnuckleCurve.key, PitchType.Slurve.key,
    PitchType.Screwball.key, PitchType.BreakingBall.key,
    // softball https://flightscope.atlassian.net/browse/BBP-891
];

const breakingBallClassifier = function(taggedPitchType) {
    if (typeof taggedPitchType !== 'string'){
        return false;
    }

    return breakingBalls.includes(taggedPitchType);
}

export default breakingBallClassifier;